import chunk from './chunk';

/**
 * Equalize elements
 * @param {Array} Items of nodes
 * @param {Number} group
 */

export default (items, group) => {
  if (items.length === 0) {
    return;
  }

  let maxHeight = 0;
  const itemsToEqualize = [ ...items ];

  itemsToEqualize.forEach(item => {
    // eslint-disable-next-line no-param-reassign
    item.style.minHeight = 'auto';
  });

  if (group === 1) {
    itemsToEqualize.forEach(item => {
      const itemHeight = item.offsetHeight;

      if (maxHeight < itemHeight) {
        maxHeight = itemHeight;
      }
    });

    itemsToEqualize.forEach(item => {
      // eslint-disable-next-line no-param-reassign
      item.style.minHeight = `${maxHeight}px`;
    });

    return;
  }

  // If grouping is enabled
  const list = chunk(itemsToEqualize, group);

  list.forEach(item => {
    let listMaxHeight = 0;

    for (const element of item) {
      const itemHeight = element.offsetHeight;

      if (listMaxHeight < itemHeight) {
        listMaxHeight = itemHeight;
      }
    }

    for (const element of item) {
      element.style.minHeight = `${listMaxHeight}px`;
    }
  });
};
